import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { CTA, ThemeProvider } from '@volkswagen-onehub/components-core';
import { Emphasis } from '@volkswagen-onehub/components-core/dist/call-to-action';
import React from 'react';
import ReactDOM from 'react-dom';

@Component({
    selector: 'app-vwsa-button',
    template: ''
})
export class VWSAButtonComponent implements AfterViewInit, OnChanges, OnDestroy {
    //https://lsg-auth.prodworksngwsa.de/components-core/?path=/docs/components-cta-call-to-action--cta-call-to-action
    @Input() text = '';
    @Input() variant = 'primary';
    @Input() size = 'large';
    @Input() disabled = false;

    ElementToShow = () => (
        <ThemeProvider>
            <CTA
                tag="button"
                emphasis={this.variant as Emphasis}
                size={this.size as any}
                disabled={this.disabled}
                ariaLabel="aria label">
                {this.text}
            </CTA>
        </ThemeProvider>
    );

    constructor(private hostRef: ElementRef) { }

    ngOnChanges(changes: SimpleChanges): void {
        //console.log('ngOnChanges: ' + this.hostRef.nativeElement);
        this.render();
    }

    ngAfterViewInit(): void {
        //console.log('ngAfterViewInit');
        this.render();
    }

    ngOnDestroy(): void {
        //console.log('ngOnDestroy');
        //removing this for now because it causes delays when navigating.
        //find a way to call it async so it doesn't delay navigation
        //or change the navigation so pages are preloaded and also not destructed.
        //ReactDOM.unmountComponentAtNode(this.hostRef.nativeElement);
    }

    private render() {
        ReactDOM.render(<this.ElementToShow />, this.hostRef.nativeElement);
    }
}
